var render = function render(){var _vm=this,_c=_vm._self._c;return (!_vm.libraryCoach)?_c('coach-required'):(_vm.isMobile)?_c('calendar-mobile'):_c('calendar-desktop')
}
var staticRenderFns = []

export { render, staticRenderFns }